import { sendGAEvent, sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';

import { getTrackingEventLabel } from './getTrackingEventLabel';
import type { Level1Item, Level3Item } from 'client-site-chrome-ui/types/departmentsNav';

const EVENT_CATEGORY = 'Navigation - MDD';

export const megaNavOpen = (navigationData: Level1Item[], item: Level3Item) =>
  sendGAEvent({
    event: 'custom_event',
    event_category: EVENT_CATEGORY,
    event_action: 'Mega Nav Open',
    event_label: getTrackingEventLabel(navigationData, item),
    destination_URL: item.url,
  });

export const clickLink = (
  evt: React.MouseEvent<HTMLAnchorElement>,
  navigationData: Level1Item[],
  item: Level3Item,
) =>
  sendGALinkClickEvent(evt, {
    event: 'custom_event',
    event_category: EVENT_CATEGORY,
    event_action: 'Click',
    event_label: getTrackingEventLabel(navigationData, item),
    destination_URL: item.url,
  });
